import { createContext } from 'react';
import type { ChangeRuntime, IChangeFieldBinding, IChangeInvocation } from '@utils/managers/ChangeRuntime';

export interface IChangeHandlersContext {
    runtime: ChangeRuntime;
    runSavedChanges(
        binding: IChangeFieldBinding,
        value: any,
        rowData?: any,
        rowOldData?: any,
        invocation?: IChangeInvocation,
    ): Promise<boolean>;
}

export const ChangeHandlersContext = createContext<IChangeHandlersContext | undefined>(undefined);
